import {
  AdyenPlatformExperience,
  DevEnvironment,
} from "@adyen/adyen-platform-experience-web";
import { httpCall } from "../utils/http";

const adyenComponentsEnv: DevEnvironment =
  (process.env.REACT_APP_ADYEN_COMPONENTS_ENV as DevEnvironment) ?? "test";

export async function getAdyenPlatformExperience(
  accountHolderCode: string,
  roles: string[]
) {
  return await AdyenPlatformExperience({
    locale: "en-US",
    environment: adyenComponentsEnv,
    async onSessionCreate() {
      const sessionData = await getAdyenComponentSessionBody({
        allowOrigin: process.env.REACT_APP_BASE_URI?.slice(0, -1) ?? "",
        accountHolderId: accountHolderCode,
        roles,
      });

      return sessionData;
    },
  });
}

export type GetAdyenComponentSessionBody = {
  accountHolderId: string;
  allowOrigin: string;
  roles: string[];
};

export type GetAdyenComponentSessionResponse = {
  id: string;
  token: string;
};

export async function getAdyenComponentSessionBody(
  body: GetAdyenComponentSessionBody
) {
  return await httpCall<
    GetAdyenComponentSessionResponse,
    GetAdyenComponentSessionBody
  >("POST", {
    url: `${process.env.REACT_APP_PAYMENTS_API_URI}/AdyenComponentSession`,
    errorMessage: `Unable to Adyen component session. Please try again.`,
    body,
  });
}
